/** Packages **/
import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

const CICard = props => {

  const cardHeaderStyles = {
    background: props.backgroundColor,
    borderRadius: '3px',
    fontSize: '1rem',
    height: '84px',
    padding: '20px 30px',
    color: props.titleColor
  };
  const cardContentStyles = {
    position: 'relative',
    padding: '20px 30px',
    height: '167px',
    overflowX: 'hidden',
    overflowY: props.scrollY ? 'scroll' : 'hidden',
  };
  const cardStyles = {
    height: '250px'
  };

  return (
    <Card
      style={cardStyles}
    >
      <CardHeader
        title={props.title}
        subtitle={props.subtitle}
        style={cardHeaderStyles}
      />
      <CardContent
        style={cardContentStyles}
      >
        {props.cardContent}
      </CardContent>
    </Card>
  );
}

export default CICard


CICard.propTypes = {
  cardState: PropTypes.any.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
  title: PropTypes.any.isRequired,
  cardContent: PropTypes.any.isRequired,
  subtitle: PropTypes.string,
  scrollY: PropTypes.bool
};
CICard.defaultProps = {
  subtitle: '',
};
